/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "F:/zhaoyanning/\u627F\u5FB7\u5E02\u653F\u5E9C-\u5BF9\u63A5\u94F6\u884C/mobile-master/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { Toast } from 'vant';
import ListDate from '@/components/ListDate/indexCopy';
import dateMealPopUp from './DateMeal-popUp';
import dataeMealReviseAmount from './DateMeal-reviseAmount';
import DateMealConfirm from './DateMeal-confirm';
import DateMealOrderMeal from './DateMeal-orderMeal';
import DateMealPayment from './DateMeal-payment';
import DateMealOrderFood from './DateMeal-orderFood';
import * as util from '@/utils/common.js';
export default {
  components: {
    ListDate: ListDate,
    dateMealPopUp: dateMealPopUp,
    dataeMealReviseAmount: dataeMealReviseAmount,
    DateMealConfirm: DateMealConfirm,
    DateMealOrderMeal: DateMealOrderMeal,
    DateMealPayment: DateMealPayment,
    DateMealOrderFood: DateMealOrderFood
  },
  data: function data() {
    return {
      dtype: [{
        value: '周',
        index: 0
      }],
      //选日期的数组
      nowType: 0,
      //当前选的日期
      dateStart: '',
      //开始时间
      dateEnd: '',
      //结束时间
      showConfirm: false,
      //日历的显示
      fadeShow: false,
      //切换时间的动画
      weekList: [],
      //周数组
      timestamp: 0,
      //当前时间戳
      currDate: '',
      //日历选择的时间
      detailsShow: false,
      //订单详情
      FoodInfoShow: false,
      //订餐信息
      revampShow: false,
      //订餐修改
      revampVal: 0,
      //修改的份数
      verifyShow: false,
      //订餐确认
      foodList: [],
      list: [],
      rightNext: 0,
      leftNext: 0,
      orderDetail: {
        time: '',
        //预定时间
        mealName: '',
        // 早 中 晚
        orderNumber: '',
        // 份数
        money: '100',
        //消费金额
        status: '已定餐',
        payStatus: '支付成功'
      },
      orderBalance: 0,
      //订单差额
      isOrderMeal: false,
      //单餐订餐
      isPayment: false,
      //预定餐结果
      isSuccess: true,
      //支付成功
      isOrder: false,
      //判断是否点击了批量订餐
      num: 1,
      orderList: [],
      //批量订餐的数组
      isOrderManyMeal: false,
      placeId: '',
      tijiaoList: [],
      tijiao: '',
      nowTime: '',
      thishi: ''
    };
  },
  methods: {
    quxiaopiliang: function quxiaopiliang() {
      this.isOrder = false; // this.getRqMeals(this.zhuanhuariqi(this.currDate))
    },
    //确定订餐

    /**
     * 1:确定订餐时先将过期的排除
     * 2:筛选 mealstauts为1
     */
    comfirmOrderMeal: function comfirmOrderMeal() {
      var dateArr = []; //过期日期的序号，并将对应的订餐日期删掉

      this.weekList.forEach(function (item, index) {
        if (item.old == true) dateArr.push(index);
      });
      this.handleOverdueMeal(dateArr);
    },
    //订餐的数组中删除已过器
    handleOverdueMeal: function handleOverdueMeal(arr) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var newList, i, listArr, _loop, index;

        return regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                newList = util.deepcopy(_this.list);

                for (i = 0; i < arr.length; i++) {
                  newList.splice(0, 1); //从周一开始删除几次
                }

                _this.orderList = []; //订餐列表
                //找出批量订餐中status==0且订餐数量大于1

                /**
                 * 构建数组[
                 *  {time:'',mealArr:[]}
                 * ]
                 * 用于弹窗展示
                 */

                listArr = _this.weekList.filter(function (item) {
                  return item.old != true;
                });
                _loop = /*#__PURE__*/regeneratorRuntime.mark(function _loop(index) {
                  var item;
                  return regeneratorRuntime.wrap(function _loop$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          item = newList[index];
                          _context.next = 3;
                          return _this.findMeal(item).then(function (res) {
                            if (res) {
                              var obj = {
                                time: listArr[index].day,
                                mealArr: res
                              };

                              _this.orderList.push(obj);

                              _this.tijiaoList.push(obj);
                            }
                          });

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _loop);
                });
                index = 0;

              case 6:
                if (!(index < newList.length)) {
                  _context2.next = 11;
                  break;
                }

                return _context2.delegateYield(_loop(index), "t0", 8);

              case 8:
                index++;
                _context2.next = 6;
                break;

              case 11:
                _this.isOrderManyMeal = true;

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee);
      }))();
    },
    findMeal: function findMeal(arr) {
      return new Promise(function (resolve) {
        var list = [];
        arr.mealList.forEach(function (item) {
          if (item.status == 0 && item.num > 0) {
            list.push(item);
          }
        });
        if (list.length > 0) resolve(list);else resolve(null);
      });
    },
    //批量订餐成功 小弟无能实在没法了 期待后期大神优化代码
    paymentMeal: function paymentMeal(aaa) {
      var _this2 = this;

      var eee = aaa.map(function (item) {
        return item;
      });
      var www = [];
      eee.map(function (item) {
        item.mealArr.map(function (items) {
          www.push({
            'foodNum': items.num,
            'mealId': items.mealId,
            'orderDate': item.time,
            'mealPrice': items.reportMoney * items.num
          });
        });
      });
      var ddds = {
        'mealList': www,
        'placeId': this.placeId,
        'orderChannel': 1,
        'userSerial': this.$utils.Store.getItem('userSerial')
      };
      this.$api.Baocan.insertOrder(ddds).then(function (response) {
        _this2.$utils.Tools.loadHide();

        var code = response.code;

        if (+code !== _this2.$code.success) {
          _this2.isSuccess = true;
          _this2.thishi = "批量订餐失败";

          _this2.$refs.productImage.getSrcList(_this2.thishi);

          _this2.isPayment = true;
        } else {
          _this2.isSuccess = true;
          _this2.thishi = "批量订餐成功";

          _this2.$refs.productImage.getSrcList(_this2.thishi);

          _this2.isPayment = true;

          _this2.getSysDate();

          _this2.isOrder = false;
        }
      }).catch(function () {
        _this2.$utils.Tools.httpError();
      });
      this.isOrderManyMeal = false; // this.isPayment = true
    },
    //批量订餐减少
    reduce: function reduce(item) {
      if (item.num < 1) return;
      item.num = item.num - 1;
    },
    //批量订餐增加
    add: function add(item) {
      item.num = item.num + 1;
    },
    //点击批量订餐
    orderFood: function orderFood() {
      this.isOrder = true;
    },
    //关闭支付弹窗
    closePay: function closePay() {
      this.isPayment = false;
    },
    updataOder: function updataOder(aa) {
      var _this3 = this;

      this.$api.Baocan.updateMeal({
        subOrderId: aa.subOrderId,
        foodNum: aa.orderNumber
      }).then(function (response) {
        _this3.$utils.Tools.loadHide();

        var code = response.code;

        if (+code !== _this3.$code.success) {
          _this3.detailsShow = false;
          _this3.isSuccess = true;
          _this3.thishi = "修改订餐失败";

          _this3.$refs.productImage.getSrcList(_this3.thishi);

          if (_this3.FoodInfoShow) _this3.FoodInfoShow = false;
          if (_this3.isOrderMeal) _this3.isOrderMeal = false;
          _this3.isPayment = true;
        } else {
          _this3.detailsShow = false;
          _this3.isSuccess = true;
          _this3.thishi = "修改订餐成功";
          if (_this3.FoodInfoShow) _this3.FoodInfoShow = false;
          if (_this3.isOrderMeal) _this3.isOrderMeal = false;

          _this3.$refs.productImage.getSrcList(_this3.thishi);

          _this3.isPayment = true;

          _this3.getSysDate();

          _this3.isOrder = false;
        }
      }).catch(function () {
        _this3.$utils.Tools.httpError();
      });
    },
    //单个订餐订餐
    comfirmOrder: function comfirmOrder(aa) {
      var _this4 = this;

      this.isOrderMeal = false;
      if (this.FoodInfoShow) this.FoodInfoShow = false;
      var www = [];
      www.push({
        'foodNum': aa.orderNumber,
        'mealId': aa.mealId,
        'orderDate': aa.tijiaoTime,
        'mealPrice': aa.reportMoney * aa.orderNumber
      });
      var ddds = {
        'mealList': www,
        'placeId': this.placeId,
        'orderChannel': 1,
        'userSerial': this.$utils.Store.getItem('userSerial')
      };
      this.$api.Baocan.insertOrder(ddds).then(function (response) {
        _this4.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg;

        if (+code !== _this4.$code.success) {
          _this4.$utils.Tools.toastShow(msg);
        } else {
          _this4.isSuccess = true;
          _this4.thishi = "订餐成功,等待就餐吧";

          _this4.$refs.productImage.getSrcList(_this4.thishi);

          _this4.isPayment = true;

          _this4.getSysDate();

          _this4.isOrder = false;
        }
      }).catch(function () {
        _this4.$utils.Tools.httpError();
      });
    },
    //订单提示弹窗关闭
    closeConfirm: function closeConfirm() {
      this.verifyShow = false;
    },
    //修改金额弹窗关闭
    closeMoney: function closeMoney() {
      if (this.FoodInfoShow) this.FoodInfoShow = false;
      if (this.isOrderMeal) this.isOrderMeal = false;
    },
    //确定修改金额
    comfirmModify: function comfirmModify(money) {
      this.FoodInfoShow = false;
      this.verifyShow = true;
      this.orderBalance = money;
    },
    //撤消报餐
    closePopUpXiugai: function closePopUpXiugai(aa) {
      var _this5 = this;

      this.$api.Baocan.cancelMeal({
        subOrderId: aa.subOrderId
      }).then(function (response) {
        _this5.$utils.Tools.loadHide();

        var code = response.code;

        if (+code !== _this5.$code.success) {
          _this5.detailsShow = false;
          _this5.isSuccess = true;
          _this5.thishi = "取消订餐失败";

          _this5.$refs.productImage.getSrcList(_this5.thishi);

          _this5.isPayment = true;
        } else {
          _this5.detailsShow = false;
          _this5.isSuccess = true;
          _this5.thishi = "已取消订餐";

          _this5.$refs.productImage.getSrcList(_this5.thishi);

          _this5.isPayment = true;

          _this5.getSysDate();

          _this5.isOrder = false;
        }
      }).catch(function () {
        _this5.$utils.Tools.httpError();
      });
    },
    // 关闭订单
    closePopUp: function closePopUp() {
      this.isOrder = false;
      this.orderList = [];
      this.tijiaoList = []; // this.getSysDate();

      if (this.detailsShow) {
        this.detailsShow = false;
      }

      if (this.isOrderManyMeal) this.isOrderManyMeal = false;
    },
    //修改订单
    orderModif: function orderModif() {
      this.detailsShow = false;
      this.FoodInfoShow = true;
    },
    //显示订单详情
    showModifyMsg: function showModifyMsg(item, k, index, items) {
      if (items.diffDay == 0 && this.nowTime > item.orderEnd) {
        return;
      }

      if (this.isOrder) return;
      if (item.canOrder == 0) return; //k用判断是餐别  index 用于取时间

      this.orderDetail.mealName = this.foodList[k].mealName;
      this.orderDetail.time = this.weekList[index].day + '   周 ' + this.weekList[index].week;
      this.orderDetail.tijiaoTime = this.weekList[index].day;
      this.orderDetail.orderNumber = item.num;
      this.orderDetail.mealId = item.mealId;
      this.orderDetail.money = item.allMoney;
      this.orderDetail.reportMoney = item.reportMoney;
      this.orderDetail.unitPrice = item.unitPrice;

      if (item.subOrderId) {
        this.orderDetail.subOrderId = item.subOrderId;
      }

      if ((item.status == 1 || item.status == 4) && item.canOrder == 1) {
        this.detailsShow = true;
      } else if (item.status == 0 && item.canOrder == 1) {
        this.isOrderMeal = true;
      }
    },
    toMove: function toMove() {
      var num = Math.ceil(this.foodList.length / 3);
      if (this.rightNext + 1 == num || this.rightNext + 1 > num) return;
      this.rightNext++;
      this.leftNext = this.rightNext;
      var leftDis = -this.rightNext * 0.99 + 'rem';
      this.$refs.foodRegion.style.left = leftDis;
    },
    toMoveLeft: function toMoveLeft() {
      if (this.leftNext == 0) return;
      this.leftNext--;
      this.rightNext = this.leftNext;
      var leftDis = this.leftNext * 0.99 + 'rem';
      this.$refs.foodRegion.style.left = leftDis;
    },
    typeClick: function typeClick(index) {
      this.nowType = index;
      this.dateStart = new Date();
      this.setDateList(0);
    },
    // 切换头部时间的区间
    cutDate: function cutDate(num) {
      this.setDateList(1, num);
    },
    //  时间切换后的列表
    // type 0  默认是周/月  1 是来回切换上周/上月
    // cutDate 0 上  1 下
    setDateList: function setDateList() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var cutDate = arguments.length > 1 ? arguments[1] : undefined;
      var start, end, dayNum;

      if (this.nowType == 0) {
        if (type == 0) {
          start = this.$utils.DateUtils.getBeginWeek(this.dateStart);
        } else {
          start = cutDate == 0 ? this.$utils.DateUtils.getBeginLastWeek(this.dateStart) : this.$utils.DateUtils.lastMonday(this.dateEnd, 0);
        }

        this.getWeekList(start, 7); // dayNum=
      } else {
        if (type == 0) {
          start = this.$utils.DateUtils.getBeginMonth(this.dateStart);
        } else {
          start = cutDate == 0 ? this.$utils.DateUtils.getBeginLastMonth(this.dateStart) : this.$utils.DateUtils.getNextMonth(this.dateStart);
        }

        end = this.$utils.DateUtils.getEndMonth(start);
        dayNum = this.$utils.DateUtils.DateDiff(this.formatDate(start), this.formatDate(end));
        this.getWeekList(start, dayNum + 1);
      }
    },
    formatDate: function formatDate(date) {
      date = new Date(date);
      return "".concat(date.getFullYear(), "-").concat(date.getMonth() + 1, "-").concat(date.getDate());
    },
    onConfirm: function onConfirm(beginDate, endDate) {
      var dayNum = this.$utils.DateUtils.DateDiff(beginDate, endDate);

      if (dayNum > 7) {
        this.nowType = 1;
      } else {
        this.nowType = 0;
      }

      this.getWeekList(beginDate, dayNum + 1);
    },

    /**
     * 处理餐厅订餐情况
     *
     */
    handleMeal: function handleMeal(index) {
      var mealList = this.list[index];
      mealList.forEach(function (item) {
        item.status = '0';
      });
    },

    /**
     * @function获取当前周或者月数组
     *      wzx
     *   2019.05.05
     **/
    getWeekList: function getWeekList(value) {
      var _this6 = this;

      var numday = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;

      if (typeof value == 'string') {
        value = value.replace(/-/g, '/');
        value = new Date(value);
      }

      this.weekList = [];
      value = this.$utils.DateUtils.getTimeStamp(value) * 1000;

      for (var i = 0; i < numday; i++) {
        var curWeek = value + i * 24 * 3600 * 1000; //获取当前周几的时间戳

        this.weekList.push({
          day: this.$utils.DateUtils.formatTimeStamp(curWeek),
          week: this.$utils.DateUtils.getWeekCnOne(curWeek) // old:this.$utils.DateUtils.oldDate( this.weekList[i].day)

        }); //根据周几的时间戳返回周几的日期

        this.dateStart = this.weekList[0].day;
        this.dateEnd = this.weekList[this.weekList.length - 1].day;
        this.weekList.forEach(function (element) {
          element.old = _this6.$utils.DateUtils.oldDate(element.day);
        });
      } //找出日期中已过期的


      var oldArr = [];
      this.weekList.forEach(function (item, index) {
        if (item.old && item.old != 'today') {
          oldArr.push(index);
        }
      });
      this.getRqMeals(this.weekList[0].day); // for (let i = 0; i < oldArr.length; i++) {
      //     //处理餐厅已过期
      //     this.handleMeal(oldArr[i])
      // }
    },
    getFritWeekList: function getFritWeekList(value) {
      var _this7 = this;

      var numday = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 7;

      if (typeof value == 'string') {
        value = value.replace(/-/g, '/');
        value = new Date(value);
      }

      this.weekList = [];
      value = this.$utils.DateUtils.getTimeStamp(value) * 1000;

      for (var i = 0; i < numday; i++) {
        var curWeek = value + i * 24 * 3600 * 1000; //获取当前周几的时间戳

        this.weekList.push({
          day: this.$utils.DateUtils.formatTimeStamp(curWeek),
          week: this.$utils.DateUtils.getWeekCnOne(curWeek) // old:this.$utils.DateUtils.oldDate( this.weekList[i].day)

        }); //根据周几的时间戳返回周几的日期

        this.dateStart = this.weekList[0].day;
        this.dateEnd = this.weekList[this.weekList.length - 1].day;
        this.weekList.forEach(function (element) {
          element.old = _this7.$utils.DateUtils.oldDate(element.day);
        });
      }
    },
    zhuanhuariqi: function zhuanhuariqi(date) {
      date = new Date(date.replace(/-/g, '/'));
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? '0' + m : m;
      var d = date.getDate();
      d = d < 10 ? '0' + d : d;
      return y + '-' + m + '-' + d;
    },

    /**
     * @function获取当前日期
     *      wzx
     *   2019.04.12
     **/
    getSysDate: function getSysDate() {
      var _this8 = this;

      this.$utils.Tools.loadShow();
      this.$api.Sys.getSystemDate(this.$params.mode).then(function (response) {
        _this8.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this8.$code.success) {
          Toast(msg);
        } else {
          _this8.currDate = data.sysDate;
          _this8.nowTime = data.sysDate.substring(11, 16);
          _this8.timestamp = _this8.$utils.DateUtils.getBeginWeek(data.sysDate);

          _this8.getFritWeekList(_this8.timestamp, 7);

          _this8.getRqMeals(_this8.zhuanhuariqi(_this8.currDate));
        }
      }).catch(function () {
        _this8.$utils.Tools.httpError();
      });
    },
    getRqMeals: function getRqMeals(aa) {
      var _this9 = this;

      this.$api.Baocan.getRqMeals({
        userSerial: this.$utils.Store.getItem('userSerial'),
        dateStr: aa,
        placeId: this.placeId
      }).then(function (response) {
        _this9.$utils.Tools.loadHide();

        var code = response.code,
            msg = response.msg,
            data = response.data;

        if (+code !== _this9.$code.success) {
          _this9.$utils.Tools.toastShow(msg);
        } else {
          _this9.foodList = data.mealList;
          _this9.list = data.list;
        }
      }).catch(function () {
        _this9.$utils.Tools.httpError();
      });
    }
  },
  created: function created() {
    this.placeId = this.$route.query.placeId;
    this.getSysDate();
  }
};